import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import Toggle from 'lib/forms/toggle'

import availabilityLogic from './logic'

const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map(day => [day, I18n.t(`weekday_short.${day}`)])
const TIMES = ['morning', 'afternoon', 'evening'].map(timeOfDay => [
  timeOfDay,
  I18n.t(`react.request.availability.option_${timeOfDay}`),
  I18n.t(`react.request.availability.hint_${timeOfDay}`)
])

export const Availability = ({
  actions: { toggleAvailability, setFlexibleAvailability, toggleFlexibleAvailability },
  availability,
  availabilityFlexible,
  isRequestTeacherPage,
  withIcons
}) => {
  const toggleDayTimeAvailability = (day, time) => {
    toggleAvailability(`${day}_${time}`, withIcons)
  }

  const handleFlexibleAvailability = event => {
    event.preventDefault()
    setFlexibleAvailability()
  }

  return (
    <div className={`request-availability-screen list-choice${withIcons ? ' with-icons new-style' : ''}`}>
      {isRequestTeacherPage && <h1>{I18n.t('react.request.availability.title')}</h1>}
      <table className='simple-availability-table show-big-screen'>
        <tbody className={`${availabilityFlexible ? 'disabled' : ''}`}>
          <tr>
            <th>{''}</th>
            {DAYS.map(day => (
              <th key={day[0]}>{day[1]}</th>
            ))}
          </tr>
          {TIMES.map(([key, option, hint]) => (
            <tr key={key}>
              <td className='label'>
                <div className='label-inner'>
                  <strong>
                    {withIcons && (
                      <img
                        src={`/assets/times/${key}.svg`}
                        width='24'
                        height='24'
                        alt={`${key} icon`}
                        className='time-icon'
                      />
                    )}
                    {option}
                  </strong>
                  <span>{hint}</span>
                </div>
              </td>

              {DAYS.map(day => (
                <td key={day[0]} className='with-box'>
                  <span
                    className={`box ${availability.indexOf(`${day[0]}_${key}`) >= 0 ? 'checked' : ''} ${
                      availabilityFlexible ? 'disabled' : ''
                    }`}
                    onClick={() =>
                      withIcons
                        ? !availabilityFlexible && toggleDayTimeAvailability(day[0], key)
                        : toggleDayTimeAvailability(day[0], key)
                    }
                    data-attr='availability-field'
                  />
                </td>
              ))}
            </tr>
          ))}

          <tr className='flexibility'>
            {withIcons ? (
              <td colSpan={8}>
                <div className='toggle-flexibility'>
                  <span>{I18n.t('react.request.availability.flexible')}</span>
                  <Toggle
                    checked={availabilityFlexible}
                    onClick={toggleFlexibleAvailability}
                    dataAttr='newsletter-toggle'
                  ></Toggle>
                </div>
              </td>
            ) : (
              <>
                <td className='label'>{I18n.t('react.request.availability.flexible')}</td>
                <td className='with-box'>
                  <span className={availabilityFlexible ? 'box checked' : 'box'} onClick={handleFlexibleAvailability} />
                </td>
              </>
            )}
          </tr>
        </tbody>
      </table>

      <table className='simple-availability-table show-small-screen'>
        {/* <tbody> */}
        <tbody className={`${availabilityFlexible ? 'disabled' : ''}`}>
          <tr className='head-row'>
            <th>
              {withIcons ? (
                <div className='calendar-icon-wrapper'>
                  <img
                    src='/assets/icons/calendar.svg'
                    alt='calendar'
                    className='calendar-icon'
                    height={16}
                    width={14}
                  ></img>
                </div>
              ) : null}
            </th>
            {TIMES.map(([key, option, hint]) => (
              <td className='label' key={key}>
                {withIcons && (
                  <img
                    src={`/assets/times/${key}.svg`}
                    width='26'
                    height='26'
                    alt={`${key} icon`}
                    className='time-icon'
                  />
                )}

                <strong>{option}</strong>
                <span>{hint}</span>
              </td>
            ))}
          </tr>

          {DAYS.map((day, index) => (
            <tr className={`day-row${index === 0 ? ' first' : ''}  `} key={day[0]}>
              <th key={day[0]}>{day[1]}</th>
              {TIMES.map(time => (
                <td key={time[0]} className='with-box'>
                  <span
                    className={`box ${availability.indexOf(`${day[0]}_${time[0]}`) >= 0 ? 'checked' : ''} ${
                      availabilityFlexible ? 'disabled' : ''
                    }`}
                    onClick={() =>
                      withIcons
                        ? !availabilityFlexible && toggleDayTimeAvailability(day[0], time[0])
                        : toggleDayTimeAvailability(day[0], time[0])
                    }
                  />
                </td>
              ))}
            </tr>
          ))}
          <tr className='flexibility'>
            {withIcons ? (
              <td colSpan={4}>
                <div className='toggle-flexibility'>
                  <span>{I18n.t('react.request.availability.flexible')}</span>
                  <Toggle
                    checked={availabilityFlexible}
                    onClick={toggleFlexibleAvailability}
                    dataAttr='newsletter-toggle'
                  ></Toggle>
                </div>
              </td>
            ) : (
              <>
                <td className='label text-left' colSpan={3}>
                  {I18n.t('react.request.availability.flexible')}
                </td>
                <td className='with-box'>
                  <span className={availabilityFlexible ? 'box checked' : 'box'} onClick={handleFlexibleAvailability} />
                </td>
              </>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  )
}

Availability.propTypes = {
  actions: PropTypes.shape({
    toggleAvailability: PropTypes.func,
    setFlexibleAvailability: PropTypes.func,
    toggleFlexibleAvailability: PropTypes.func
  }),
  availability: PropTypes.array,
  availabilityFlexible: PropTypes.bool,
  isRequestTeacherPage: PropTypes.bool,
  withIcons: PropTypes.bool
}

export const ConnectedAvailability = availabilityLogic(Availability)
